console.log(`![theme / customer-testimonials]!`)

// function to handle next prev on reviews
function handle_review_request(elm) {
    function load_reviews(url) {
        fetch(url).then(function (response) {
            return response.text();
        }).then(function (html) {
            const div = document.querySelector("#business-reviews-content-container > div > div")
            if (div) {
                div.innerHTML = html
            }
        }).catch(function (err) {
            console.error("failed to load page " + url + "; error", err);
        });
    }

    let url = "https://cdn.ozziescripts.pw/reviews/acquire/html/";

    if ("next" === elm.dataset.type) {
        url += parseInt(elm.dataset.page) + 1;
    } else if ("prev" === elm.dataset.type) {
        url += parseInt(elm.dataset.page) - 1;
    } else {
        console.error("invalid type of review trigger");
        return;
    }
    load_reviews(url + "?repeat_last=true&size=" + elm.dataset.size);
}

(function () {
    'use strict';

    function fetch_set_reviews(url, elm) {
        fetch(url).then(function (response) {
            return response.text();
        }).then(function (html) {
            elm.innerHTML = html
        }).catch(function (err) {
            console.error("failed to load page " + url + "; error", err);
        });
    }

    document.addEventListener("DOMContentLoaded", function (event) {

        const customerTestimonialsPageReviewContainer = document.querySelector("#business-reviews-content-container-master-customer-testimonial");
        const productPageReviewContainer = document.querySelector("#business-reviews-content-container-product-page");

        if (customerTestimonialsPageReviewContainer) {
            fetch_set_reviews("https://cdn.ozziescripts.pw/reviews/root/html/?size=25&delete_title=true", customerTestimonialsPageReviewContainer);
            document.querySelector(".business-review--title").remove();
        }
        if (productPageReviewContainer) {
            fetch_set_reviews("https://cdn.ozziescripts.pw/reviews/root/html/?size=10", productPageReviewContainer);
        }
    });
})()
